module.exports = __webpack_public_path__ + "static/media/nft8.cdbe9313.jpg";